<template>
  <Detail side="front" closeicon="close" />
</template>

<script>
import Detail from "@/components/Detail.vue";
export default {
  components: { Detail },
};
</script>

<style>
</style>